import { FC } from 'react';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import ViewPeriodCheckbookTable from './ViewPeriodCheckbookTable';
import ViewYearCheckbookTable from './ViewYearCheckbookTable';

interface ViewCheckbookTableProps {}

const ViewCheckbookTable: FC<ViewCheckbookTableProps> = () => {
  const { isPeriodView } = useViewCheckbook();
  return <>{isPeriodView ? <ViewPeriodCheckbookTable /> : <ViewYearCheckbookTable />}</>;
};
export default ViewCheckbookTable;
